import request from '@/utils/request';
import { newHost } from '@/global-config';

// eslint-disable-next-line import/prefer-default-export
export function exportBill(data) {
  return request({
    url: '/reconciliation/exportReconciliation',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

export function exportReconciliationShort(data) {
  return request({
    url: '/reconciliation/exportReconciliationShort',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

// eslint-disable-next-line import/prefer-default-export
export function exportActivityBill(data) {
  return request({
    url: '/reconciliation/exportSubsidy',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

// eslint-disable-next-line import/prefer-default-export
export function exportSettlementDetail(data) {
  return request({
    url: '/reconciliation/exportSubsidy',
    method: 'post',
    data,
    baseURL: newHost,
  });
}
